// src/components/priming-card/priming-card.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGClickStreamEventFragment on EGClickstreamEvent {\n    __typename\n    eventCategory\n    eventName\n    eventType\n    eventVersion\n    actionLocation\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    spotLight\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    url\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicFragment on UIGraphic {\n    __typename\n    ... on Icon {\n      ...EGDSIconFragment\n    }\n    ... on Illustration {\n      ...EGDSIllustrationFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n    accessibility\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconTextFragment on EGDSIconText {\n    text\n    iconText: icon {\n      ...EGDSIconFragment\n    }\n  }\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    text\n    action {\n      accessibility\n      resource {\n        value\n      }\n      standardLinkAnalytics: analytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n    icon {\n      ...EGDSIconFragment\n    }\n    iconPosition\n    egdsElementId\n  }\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSTextFragment on EGDSText {\n    __typename\n    ...EGDSParagraphFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSHeadingFragment\n    ...EGDSIconTextFragment\n    ...EGDSStandardLinkFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicSectionHeadingFragment on EGDSBasicSectionHeading {\n    graphic {\n      ...EGDSGraphicFragment\n    }\n    heading {\n      ...EGDSHeadingFragment\n    }\n    subheading\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment BasicPrimingCardFragment on InsurtechPrimingCard {\n    header {\n      ...EGDSHeadingFragment\n    }\n    description\n    displayAnalytics {\n      ...EGClickStreamEventFragment\n    }\n    graphic {\n      ...EGDSGraphicFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  query InsurtechPrimingCardQuery($context: ContextInput!, $placement: InsurTechComponentPlacementInput!) {\n    insurtechPriming(context: $context) {\n      card(placement: $placement) {\n        ...BasicPrimingCardFragment\n        viewType\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
import React14 from "react";
import { gql as gql15, useQuery } from "@apollo/client";
import { UitkSpacing as UitkSpacing3 } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/common/loading-animation.tsx
import React from "react";
import { UitkLayoutGrid, UitkLayoutGridItem } from "@egds/react-core/layout-grid";
import { UitkLineSkeleton } from "@egds/react-core/skeleton";
var LoadingAnimation = function (param) {
  var _param_numberOflines = param.numberOflines,
    numberOflines = _param_numberOflines === void 0 ? 1 : _param_numberOflines;
  return /* @__PURE__ */React.createElement(UitkLayoutGrid, {
    space: "three",
    columns: ["40x"]
  }, /* @__PURE__ */React.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React.createElement(UitkLineSkeleton, {
    animation: true
  })), Array.from(Array(numberOflines), function (e, key) {
    return /* @__PURE__ */React.createElement(UitkLayoutGridItem, {
      key: key
    }, /* @__PURE__ */React.createElement(UitkLineSkeleton, {
      animation: true,
      type: "secondary"
    }));
  }));
};
// src/components/priming-card/__private/__fragments/basic-priming-card.tsx
import React13 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkCard, UitkCardBackgroundThemes } from "@egds/react-core/cards";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { UitkSpacing as UitkSpacing2 } from "@egds/react-core/spacing";
import { UitkText as UitkText5 } from "@egds/react-core/text";
// ../internal/src/components/common/eg-clickstream-event-fragment.tsx
import { gql } from "@apollo/client";
var clickStreamEventFragment = gql(_templateObject());
// ../internal/src/components/egds/egds-graphic/egds-icon.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "@egds/react-core/icons";
var _obj;
// ../internal/src/components/egds/egds-graphic/__private/mapper.ts
var iconSpotlightMapper = (_obj = {}, _define_property(_obj, "INFO" /* INFO */, "info"), _define_property(_obj, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj, "STANDARD" /* STANDARD */, "standard"), _define_property(_obj, "WARNING" /* WARNING */, "warning"), _obj);
// ../internal/src/components/egds/egds-graphic/egds-icon.tsx
var fragment = gql2(_templateObject1());
var EGDSIcon = function (param) /* @__PURE__ */{
  var data = param.data;
  var _data_title, _data_title1, _data_theme;
  return React2.createElement(UitkIcon, {
    id: "".concat(data.id, "_").concat((_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0),
    name: data.id,
    size: data.size ? UitkIconSize[data.size] : void 0,
    description: data.description,
    title: (_data_title1 = data.title) !== null && _data_title1 !== void 0 ? _data_title1 : void 0,
    theme: (_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : void 0,
    spotlight: data.spotLight ? iconSpotlightMapper[data.spotLight] : void 0
  });
};
EGDSIcon.fragment = fragment;
EGDSIcon.displayName = "EGDSIcon";
// ../internal/src/components/egds/egds-graphic/egds-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/egds/egds-graphic/egds-illustration.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkIllustrations } from "@egds/react-core/illustrations";
var fragment2 = gql3(_templateObject2());
var EGDSIllustration = function (param) {
  var data = param.data;
  return /* @__PURE__ */React3.createElement(UitkIllustrations, {
    alt: data.description,
    url: data.url
  });
};
EGDSIllustration.fragment = fragment2;
EGDSIllustration.displayName = "EGDSIllustration";
// ../internal/src/components/egds/egds-graphic/egds-graphic.tsx
var fragment3 = gql4(_templateObject3(), EGDSIcon.fragment, EGDSIllustration.fragment);
var EGDSGraphic = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React4.createElement(EGDSIcon, {
        data: data
      });
    case "Illustration":
      return /* @__PURE__ */React4.createElement(EGDSIllustration, {
        data: data
      });
    default:
      return null;
  }
};
EGDSGraphic.fragment = fragment3;
EGDSGraphic.displayName = "EGDSGraphic";
// ../internal/src/components/egds/egds-text/egds-text.tsx
import React11 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/egds/egds-text/egds-heading.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkHeading } from "@egds/react-core/text";
var fragment4 = gql5(_templateObject4());
var EGDSHeading = function (_param) {
  var data = _param.data,
    headingProps = _object_without_properties(_param, ["data"]);
  var text = data.text,
    accessibility = data.accessibility;
  return /* @__PURE__ */React5.createElement(UitkHeading, _object_spread({
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : text
  }, headingProps), text);
};
EGDSHeading.fragment = fragment4;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds/egds-text/egds-icon-text.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
var fragment5 = gql6(_templateObject5(), EGDSIcon.fragment);
var DefaultIconSpacing = {
  inlineend: "one"
};
var EGDSIconText = function (param) {
  var data = param.data,
    iconSpacing = param.iconSpacing,
    weight = param.weight;
  return /* @__PURE__ */React6.createElement(UitkLayoutFlex, {
    alignItems: "center"
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React6.createElement(UitkSpacing, {
    margin: iconSpacing !== null && iconSpacing !== void 0 ? iconSpacing : DefaultIconSpacing
  }, /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement(EGDSIcon, {
    data: data.iconText
  })))), /* @__PURE__ */React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React6.createElement(UitkText, {
    weight: weight
  }, data.text)));
};
EGDSIconText.fragment = fragment5;
EGDSIconText.displayName = "EGDSIconText";
// ../internal/src/components/egds/egds-text/egds-paragraph.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkParagraph } from "@egds/react-core/text";
var fragment6 = gql7(_templateObject6());
var EGDSParagraph = function (param) {
  var data = param.data;
  return /* @__PURE__ */React7.createElement(UitkParagraph, null, data.text);
};
EGDSParagraph.fragment = fragment6;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds/egds-text/egds-plain-text.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkText as UitkText2 } from "@egds/react-core/text";
var fragment7 = gql8(_templateObject7());
var EGDSPlainText = function (_param) {
  var data = _param.data,
    textProps = _object_without_properties(_param, ["data"]);
  return /* @__PURE__ */React8.createElement(UitkText2, _object_spread({}, textProps), data.text);
};
EGDSPlainText.fragment = fragment7;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds/egds-text/egds-standard-link.tsx
import React9 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkLink } from "@egds/react-core/link";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/clickstream/clickstream-constants.ts
var LINK_CLICKED_CONSTANTS = {
  __typename: "ClickStreamEventConstants",
  EVENT_NAME: "insurance_link.selected",
  EVENT_TYPE: "Interaction" /* INTERACTION */,
  EVENT_VERSION: "1.0.0",
  ACTION_LOCATION: "insurance_module"
};
// ../internal/src/utils/clickstream/clickstream-utils.ts
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/clickstream/clickstream-mapper.ts
var clickStreamDataMapper = function (data) {
  var convertFromConstant = function (eventData) {
    return {
      event: _object_spread({
        event_type: eventData.EVENT_TYPE,
        event_name: eventData.EVENT_NAME,
        event_version: eventData.EVENT_VERSION
      }, eventData.ACTION_LOCATION && {
        action_location: eventData.ACTION_LOCATION
      }, eventData.ACTION_REASON && {
        action_reason: eventData.ACTION_REASON
      })
    };
  };
  var convertFromEGEvent = function (eventData) {
    return {
      event: {
        event_type: eventData.eventType,
        event_name: eventData.eventName,
        event_version: eventData.eventVersion,
        event_category: eventData.eventCategory,
        action_location: eventData.actionLocation
      }
    };
  };
  var convertToEvent = function () {
    switch (data.__typename) {
      case "EGClickstreamEvent":
        return convertFromEGEvent(data);
      case "ClickStreamEventConstants":
        return convertFromConstant(data);
      default:
        return null;
    }
  };
  return {
    convertToEvent: convertToEvent
  };
};
// ../internal/src/utils/clickstream/clickstream-utils.ts
var getClickStreamEventByName = function (event, egClickStreamAnalyticsArray) {
  switch (event.__typename) {
    case "ClickStreamEventConstants":
      return (egClickStreamAnalyticsArray || []).find(function (param) {
        var eventName = param.eventName;
        return eventName === event.EVENT_NAME;
      });
    case "EGClickstreamEvent":
      return (egClickStreamAnalyticsArray || []).find(function (param) {
        var eventName = param.eventName;
        return eventName === event.eventName;
      });
    default:
      return null;
  }
};
var usePublishClickStreamEvent = function () {
  var track = useEgClickstream();
  var publishClickStreamEvent = function (clientClickStreamData, egClickStreamAnalytics) {
    var clientPayload = clickStreamDataMapper(clientClickStreamData).convertToEvent();
    var serverPayload = getClickStreamEventByName(clientClickStreamData, egClickStreamAnalytics);
    track({
      clientPayload: clientPayload || void 0,
      serverPayload: serverPayload === null || serverPayload === void 0 ? void 0 : serverPayload.payload
    });
  };
  return publishClickStreamEvent;
};
// ../internal/src/components/common/client-side-analytics.ts
import { gql as gql9 } from "@apollo/client";
var ClientSideAnalyticsFragment = gql9(_templateObject8());
// ../internal/src/components/egds/egds-text/egds-standard-link.tsx
var fragment8 = gql10(_templateObject9(), EGDSIcon.fragment, ClientSideAnalyticsFragment);
var EGDSStandardLink = function (param) {
  var data = param.data,
    inline = param.inline,
    trackData = param.trackData,
    linkSize = param.linkSize;
  var _data_action_resource, _data_action, _data_action1;
  var publishClickStreamEvent = usePublishClickStreamEvent();
  var clickTrack = useClickTracker();
  var egClickStreamAnalytics = (trackData || []).filter(function (param) {
    var referenceId = param.referenceId;
    return referenceId === data.egdsElementId;
  });
  var tmp = data.action,
    _ref = tmp === void 0 ? {} : tmp,
    analytics = _ref.standardLinkAnalytics;
  var onClick = React9.useCallback(function () {
    if (analytics) {
      clickTrack(analytics.referrerId, analytics.linkName);
    }
    publishClickStreamEvent === null || publishClickStreamEvent === void 0 ? void 0 : publishClickStreamEvent(LINK_CLICKED_CONSTANTS, egClickStreamAnalytics);
  }, [publishClickStreamEvent, trackData, analytics]);
  var _data_action_accessibility;
  return /* @__PURE__ */React9.createElement(UitkLink, {
    size: linkSize,
    inline: inline,
    onClickCapture: onClick
  }, /* @__PURE__ */React9.createElement("a", {
    href: (_data_action = data.action) === null || _data_action === void 0 ? void 0 : (_data_action_resource = _data_action.resource) === null || _data_action_resource === void 0 ? void 0 : _data_action_resource.value,
    "aria-label": (_data_action_accessibility = (_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : _data_action1.accessibility) !== null && _data_action_accessibility !== void 0 ? _data_action_accessibility : void 0,
    rel: "noopener noreferrer",
    target: "_blank"
  }, data.icon && data.iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React9.createElement(EGDSIcon, {
    data: data.icon
  }), data.text, data.icon && data.iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React9.createElement(EGDSIcon, {
    data: data.icon
  })));
};
EGDSStandardLink.fragment = fragment8;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds/egds-text/egds-stylized-text.tsx
import React10 from "react";
import { gql as gql11 } from "@apollo/client";
import { UitkText as UitkText3 } from "@egds/react-core/text";
var _obj1;
// ../internal/src/components/egds/egds-text/utils/text-theme-mapper.ts
var textThemeMapper = (_obj1 = {}, _define_property(_obj1, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj1, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj1, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj1, "SECONDARY" /* SECONDARY */, "secondary"), _define_property(_obj1, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj1, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj1, "EMPHASIS" /* EMPHASIS */, "emphasis"), _obj1);
var _obj2;
// ../internal/src/components/egds/egds-text/utils/text-weight-mapper.ts
var textWeightMapper = (_obj2 = {}, _define_property(_obj2, "BOLD" /* BOLD */, "bold"), _define_property(_obj2, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj2, "REGULAR" /* REGULAR */, "regular"), _obj2);
// ../internal/src/components/egds/egds-text/egds-stylized-text.tsx
var fragment9 = gql11(_templateObject10());
var EGDSStylizedText = function (param) {
  var data = param.data,
    inline = param.inline,
    size = param.size;
  return /* @__PURE__ */React10.createElement(UitkText3, {
    weight: data.weight ? textWeightMapper[data.weight] : void 0,
    theme: data.theme ? textThemeMapper[data.theme] : void 0,
    size: size,
    inline: inline
  }, data.text);
};
EGDSStylizedText.fragment = fragment9;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds/egds-text/egds-text.tsx
var fragment10 = gql12(_templateObject11(), EGDSParagraph.fragment, EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSHeading.fragment, EGDSIconText.fragment, EGDSStandardLink.fragment);
var EGDSText = function (_param) {
  var data = _param.data,
    trackData = _param.trackData,
    textProps = _object_without_properties(_param, ["data", "trackData"]);
  switch (data.__typename) {
    case "EGDSParagraph":
      return /* @__PURE__ */React11.createElement(EGDSParagraph, {
        data: data
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React11.createElement(EGDSPlainText, _object_spread({
        data: data
      }, textProps));
    case "EGDSStylizedText":
      return /* @__PURE__ */React11.createElement(EGDSStylizedText, _object_spread({
        data: data
      }, textProps));
    case "EGDSHeading":
      return /* @__PURE__ */React11.createElement(EGDSHeading, {
        data: data,
        size: textProps.headingSize,
        tag: textProps.tag
      });
    case "EGDSIconText":
      return /* @__PURE__ */React11.createElement(EGDSIconText, {
        data: data,
        weight: textProps.weight
      });
    case "EGDSStandardLink":
      return /* @__PURE__ */React11.createElement(EGDSStandardLink, {
        data: data,
        inline: textProps.inline,
        trackData: trackData
      });
    default:
      return null;
  }
};
EGDSText.fragment = fragment10;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/egds/egds-text/egds-basic-section-heading.tsx
import React12 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { UitkText as UitkText4 } from "@egds/react-core/text";
var fragment11 = gql13(_templateObject12(), EGDSHeading.fragment, EGDSGraphic.fragment);
var EGDSBasicSectionHeading = function (param) {
  var data = param.data;
  return /* @__PURE__ */React12.createElement(UitkLayoutFlex2, {
    space: "two"
  }, data.graphic && /* @__PURE__ */React12.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React12.createElement(EGDSGraphic, {
    data: data.graphic
  })), /* @__PURE__ */React12.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(EGDSHeading, {
    size: 7,
    data: data.heading
  }), data.subheading && /* @__PURE__ */React12.createElement(UitkText4, {
    size: 200
  }, data.subheading))));
};
EGDSBasicSectionHeading.fragment = fragment11;
EGDSBasicSectionHeading.displayName = "EGDSBasicSectionHeading";
// src/components/priming-card/__private/__fragments/basic-priming-card.tsx
var fragment12 = gql14(_templateObject13(), EGDSGraphic.fragment, EGDSHeading.fragment, clickStreamEventFragment);
var contentMargin = {
  inline: "three"
};
var BasicPrimingCard = function (props) {
  var data = props.data,
    backgroundTheme = props.backgroundTheme;
  var header = data.header,
    description = data.description,
    graphic = data.graphic,
    displayAnalytics = data.displayAnalytics;
  var theme = backgroundTheme !== null && backgroundTheme !== void 0 ? backgroundTheme : UitkCardBackgroundThemes.HIGHLIGHT;
  var publishClickStreamEvent = usePublishClickStreamEvent();
  React13.useEffect(function () {
    displayAnalytics === null || displayAnalytics === void 0 ? void 0 : displayAnalytics.forEach(function (element) {
      publishClickStreamEvent(element);
    });
  }, []);
  return /* @__PURE__ */React13.createElement(UitkCard, {
    border: true,
    padded: true,
    backgroundTheme: theme
  }, /* @__PURE__ */React13.createElement(UitkLayoutFlex3, {
    alignItems: "center"
  }, graphic && /* @__PURE__ */React13.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React13.createElement(EGDSGraphic, {
    data: graphic
  })), /* @__PURE__ */React13.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React13.createElement(UitkSpacing2, {
    margin: contentMargin
  }, /* @__PURE__ */React13.createElement("div", null, header && /* @__PURE__ */React13.createElement(EGDSHeading, {
    data: header,
    size: 6,
    tag: "h6"
  }), description && /* @__PURE__ */React13.createElement(UitkText5, {
    size: 300,
    weight: "regular",
    theme: "standard",
    spacing: "two"
  }, description))))));
};
BasicPrimingCard.displayName = "BasicPrimingCard";
BasicPrimingCard.fragment = fragment12;
// src/__generated__/types.ts
var InsurTechPagePlacementType = /* @__PURE__ */function (InsurTechPagePlacementType2) {
  InsurTechPagePlacementType2["LISTING"] = "LISTING";
  InsurTechPagePlacementType2["LISTING_ONE_WAY"] = "LISTING_ONE_WAY";
  return InsurTechPagePlacementType2;
}(InsurTechPagePlacementType || {});
// src/components/priming-card/__private/__fragments/priming-card-components-map.ts
var InsurtechPrimingViewMap = _define_property({}, "BASIC_PRIMING_CARD" /* BASIC_PRIMING_CARD */, BasicPrimingCard);
// src/components/priming-card/priming-card.tsx
var __Query = gql15(_templateObject14(), BasicPrimingCard.fragment);
var CardWrapper = function (param) {
  var children = param.children,
    spacingProps = param.spacingProps;
  return spacingProps ? /* @__PURE__ */React14.createElement(UitkSpacing3, _object_spread({}, spacingProps), /* @__PURE__ */React14.createElement("div", null, children)) : /* @__PURE__ */React14.createElement(React14.Fragment, null, children);
};
var PrimingCard = function (props) {
  var context = useBexApi().context;
  var inputs = props.inputs,
    backgroundTheme = props.backgroundTheme,
    spacingProps = props.spacingProps,
    showSkeletonView = props.showSkeletonView,
    onError = props.onError;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var cardData = data === null || data === void 0 ? void 0 : data.insurtechPriming.card;
  if (error) {
    onError === null || onError === void 0 ? void 0 : onError();
    return null;
  }
  if (loading && showSkeletonView) {
    return /* @__PURE__ */React14.createElement(LoadingAnimation, null);
  }
  if (loading || !cardData) {
    return null;
  }
  var View = InsurtechPrimingViewMap[cardData.viewType];
  return /* @__PURE__ */React14.createElement(CardWrapper, {
    spacingProps: spacingProps
  }, /* @__PURE__ */React14.createElement(View, {
    data: cardData,
    backgroundTheme: backgroundTheme
  }));
};
PrimingCard.displayName = "sharedui-InsurtechPriming";
export { InsurTechPagePlacementType, PrimingCard };